import { Popover, Tag } from "antd"
import dayjs from "dayjs"

export const InteractivePaymentStatus = ({ record, documentType = "invoice" }) => {
  const { paymentStatus } = record

  // 1. Dynamically select the correct timestamp field based on the prop
  let paymentTimestamp
  if (documentType === "proforma") {
    paymentTimestamp = record.paidDateProformaTimestamp
  } else {
    // Default to invoice
    paymentTimestamp = record.paidDateInvoiceTimestamp
  }

  // Handle the 'Paid' case (status 2)
  if (paymentStatus === 2) {
    const paymentDate = paymentTimestamp
      ? dayjs.unix(paymentTimestamp.seconds).format("DD.MM.YYYY HH:mm")
      : "Date not available"

    const popoverContent = (
      <div>
        <p style={{ margin: 0 }}>
          <strong>Paid on:</strong> {paymentDate}
        </p>
      </div>
    )

    return (
      <Popover content={popoverContent} title="Payment Details" trigger="click">
        <Tag color="success" style={{ cursor: "pointer" }}>
          Paid
        </Tag>
      </Popover>
    )
  }

  // Handle the 'Partial Paid' case (status 1)
  if (paymentStatus === 1) {
    return <Tag color="warning">Partial</Tag>
  }

  // Handle the 'Not Paid' case (status 0)
  return <Tag color="error">Not Paid</Tag>
}
